import TemplateModel from "../../Loyalty/Models/Template/TemplateModel";
import ClassicQuizBasicModel from "../../MiniGames/Models/ClassicQuiz/ClassicQuizBasicModel";
import PersonalityQuizBasicModel from "../../MiniGames/Models/PersonalityQuiz/PersonalityQuizBasicModel";
import EitherOrBasicModel from "../../MiniGames/Models/EitherOr/EitherOrBasicModel";
import GamesListModel from "../../TopX/Models/Games/GamesListModel";
import PollBasicModel from "../../Voting/Models/Polls/PollBasicModel";

export type ListEntityType =
  | "CLASSIC_QUIZ"
  | "PERSONALITY_QUIZ"
  | "EITHER_OR"
  | "POLL"
  | "TOP_X"
  | "MATCH_QUIZ"
  | "LEADERBOARD_TEMPLATES";

// Create a mapped type for entity models
// That way we can easily access the model type based on the entity type using discriminated union type
export type ListEntityModelMap = {
  CLASSIC_QUIZ: ClassicQuizBasicModel;
  PERSONALITY_QUIZ: PersonalityQuizBasicModel;
  EITHER_OR: EitherOrBasicModel;
  POLL: PollBasicModel;
  TOP_X: GamesListModel;
  MATCH_QUIZ: GamesListModel;
  LEADERBOARD_TEMPLATES: TemplateModel;
};

export default class ListContentModel {
  public entityId: string;
  public entityType: ListEntityType;
  public entityModel: ListEntityModelMap[ListEntityType] | null = null;
}
